import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Brooklyn';

    // override the default Preset here
}
